<template>
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    class="icon-svg icon-return"
  ><path
    d="M18.667 2A3.337 3.337 0 0 1 22 5.333v13.334A3.337 3.337 0 0 1 18.667 22H5.333A3.337 3.337 0 0 1 2 18.667V5.333A3.337 3.337 0 0 1 5.333 2h13.334Zm0 1.333H5.333c-1.103 0-2 .897-2 2v13.334c0 1.103.897 2 2 2h13.334c1.103 0 2-.897 2-2V5.333c0-1.103-.897-2-2-2Zm-12 4c.368 0 .666.299.666.667v8A.667.667 0 0 1 6 16V8c0-.368.299-.667.667-.667Zm6 .666a.66.66 0 0 1 .472.196.66.66 0 0 1 .195.47.66.66 0 0 1-.195.472l-2.196 2.195h6.39a.667.667 0 0 1 0 1.334h-6.39l2.196 2.195A.668.668 0 0 1 12.667 16a.66.66 0 0 1-.471-.196l-3.334-3.333a.658.658 0 0 1-.145-.218l-.009-.023a.655.655 0 0 1 .001-.463l.007-.019a.658.658 0 0 1 .148-.22l3.332-3.333a.662.662 0 0 1 .472-.196Z"
    fill-rule="evenodd"
  /></svg>
</template>
